import axios from "axios";
import Errores from "@/utils/Errores";

const obtenerResultados = async (runPostulante, componente) => {
  return await axios
    .get(
      API.RESULTADOS + "resultados/postulante?runPostulante=" + runPostulante
    )
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      Errores.switchErrors(error, componente, [
        {
          codigo: 404,
          mensaje: ""
        }
      ]);
      return [];
    });
};

export default {
  obtenerResultados
};



// WEBPACK FOOTER //
// ./src/services/ApiResultados.js